module.exports = __webpack_public_path__ + "img/74_M16_knock_knock_who.2f52bc6b.jpg";